/**
 * @generated SignedSource<<a7acd4fdac714183594e0f74c64fff0f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CommentDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type CommentDeleteMutation$data = {
  readonly deleteComment: string;
};
export type CommentDeleteMutation = {
  response: CommentDeleteMutation$data;
  variables: CommentDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*:: as any*/),
  "kind": "ScalarField",
  "name": "deleteComment",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentDeleteMutation",
    "selections": [
      (v3/*:: as any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CommentDeleteMutation",
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "deleteComment",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "813b8ca2166fd1823f89caffdd6dbccf",
    "id": null,
    "metadata": {},
    "name": "CommentDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation CommentDeleteMutation(\n  $id: ID!\n) {\n  deleteComment(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "b44b9fdcef4545b0d6ade52209fd499d";

export default node;
